import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useSEO from "@/hooks/useSEO";

const CategoriesPage = () => {
  const [cats, setCats] = useState([]);
  useSEO({
    title: "Sustainable Shopping Categories – Fashion, Beauty, Home & More | Ecowallet",
    description: "Browse sustainable products by category: sustainable fashion, sustainable beauty, sustainable home, sustainable electronics, sustainable food & more.",
    keywords: "sustainable fashion, sustainable beauty, sustainable food, sustainable electronics, sustainable home, sustainable personal care",
  });
  useEffect(() => {
    api.get("/products/categories").then((r) => setCats(r.data));
  }, []);

  const emojis = {
    "Beauty & Personal Care": "💄", "Home & Kitchen": "🍽️", "Fashion": "👕",
    "Electronics": "🔌", "Food & Beverage": "☕", "Baby & Kids": "🧸",
    "Fitness": "🧘", "Office & Stationery": "📓",
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-4xl font-bold tracking-tight">Categories</h1>
      <p className="text-muted-foreground mt-2 mb-10">Browse sustainable products by category.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="categories-grid">
        {cats.map((c, i) => (
          <motion.div
            key={c}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
          >
            <Link
              to={`/products?category=${encodeURIComponent(c)}`}
              className="card-premium p-6 flex flex-col justify-between h-40 hover:-translate-y-1 transition-all"
              data-testid={`category-${c}`}
            >
              <div className="text-4xl">{emojis[c] || "🌱"}</div>
              <div>
                <div className="font-semibold text-lg">{c}</div>
                <div className="text-xs text-muted-foreground mt-1">Explore →</div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CategoriesPage;
